import React from 'react';
import styles from './BudgetDisplay.module.css';

interface BudgetDisplayProps {
  monthlyIncome: number;
  needs: number;
  wants: number;
  savings: number;
}

const BudgetDisplay: React.FC<BudgetDisplayProps> = ({
  monthlyIncome,
  needs,
  wants,
  savings
}) => {
  return (
    <div className={styles.budgetDisplay}>
      <div className={styles.header}>
        <h2 className={styles.title}>Your 50/30/20 Budget</h2>
        <p className={styles.subtitle}>
          Based on ${monthlyIncome.toLocaleString()} monthly income
        </p>
      </div>

      <div className={styles.budgetGrid}>
        <div className={styles.budgetCard + ' ' + styles.needs}>
          <div className={styles.percentage}>50%</div>
          <div className={styles.category}>Needs</div>
          <div className={styles.amount}>${needs.toLocaleString()}</div>
          <div className={styles.description}>
            Rent, groceries, utilities, minimum debt payments
          </div>
        </div>

        <div className={styles.budgetCard + ' ' + styles.wants}>
          <div className={styles.percentage}>30%</div>
          <div className={styles.category}>Wants</div>
          <div className={styles.amount}>${wants.toLocaleString()}</div>
          <div className={styles.description}>
            Dining out, entertainment, hobbies, shopping
          </div>
        </div>

        <div className={styles.budgetCard + ' ' + styles.savings}>
          <div className={styles.percentage}>20%</div>
          <div className={styles.category}>Savings</div>
          <div className={styles.amount}>${savings.toLocaleString()}</div>
          <div className={styles.description}>
            Emergency fund, retirement, investments
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudgetDisplay;